
export const paymentProcessingStatus = {
    pleaseWait: 'Vennligst vent...',
    paymentCheck: 'Sjekker betaling',
    completed: 'Fullført'
};

export const paymentMethod = {
    creditCard: 'Credit card',
    invoice: 'Invoice'
};

export const responseCode = {
    cancel: 'Cancel',
    ok: 'OK'
};

export const transactionLogDescription = {
    paymentCancelDesc: 'Payment cancel',
    orderConfirmManualDesc: 'Order confirmed - using manual process',
    orderCompletedManualDesc: 'Order Completed - using manual process',
    orderFailedManualDesc: 'Order Failed (Send email) - using manual process',
    orderConfirmCreditCardDesc: 'Order Confirmed - using credit card',
    manualInvoiceCreationFailedDesc: 'Invoice creation failed - using manual process',
    creditCardPaymentInvoiceCreationFailedDesc: 'Invoice creation failed - using credit card',
    creditCardPaymentThankYouEmailFailedDesc: 'Receipt email send failed - using credit card'
};

export const paymentProcessingStatusId = {
    authentication: '3',
    capture: '4',
    cancel: '5'
};

export const template = {
    default: 'defaultTemplate',
    promo: 'templateFREE'
};

export const country = {
    norway: 'Norge',
};



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/helpers/string-helper.ts